import {useEffect, useState} from "react";
import FunctionsData from "../../../Functions/FunctionsData";
import {Button, FormControl, FormControlLabel, FormHelperText, Switch, TextField} from "@mui/material";
import * as React from "react";
import RedeemVoucherShowHeaderOwner from "./RedeemVoucherShowHeaderOwner";
import RedeemVoucherShowAnimalSingleForm from "./RedeemVoucherShowAnimalSingleForm";

export default function RedeemVoucherShowAddressCheck({row, setRow, animal, setAnimal, setShowModal, showModal, setReloadOriginal, microchips, open,setOpen}) {

    const [verified, setVerified] = useState(false);
    const [change, setChange] = useState(false);
    const [emailValid, setEmailValid] = useState(false);
    const [phoneValid, setPhoneValid] = useState(false);
    const [frmFn, setFrmFn] = useState("");
    const [frmLn, setFrmLn] = useState("");
    const [frmStreetNumber, setFrmStreetNumber] = useState("");
    const [frmStreet, setFrmStreet] = useState("");
    const [frmSuburb, setFrmSuburb] = useState("");
    const [frmCity, setFrmCity] = useState("");
    const [postCode, setPostCode] = useState("");
    const [frmEmail, setFrmEmail] = useState("");
    const [frmPhone, setFrmPhone] = useState("");
    const [valid, setValid] = useState(false);
    const [emailAllowed, setEmailAllowed] = useState((row.owner_email_allowed > 0));

    useEffect(() => {
        setEmailValid(
            validateEmail(frmEmail, emailAllowed)
        );

        setPhoneValid(
            validatePhone(frmPhone)
        );

        setValid(
            validatePhone(frmPhone) === true &&
            (validateEmail(frmEmail, emailAllowed) || !emailAllowed) &&
            frmLn !== '' &&
            frmFn !== '' &&
            frmStreet !== '' &&
            frmStreetNumber !== '' &&
            frmCity !== '' &&
            postCode !== ''
        );
    }, [frmFn, frmLn, frmStreetNumber, frmStreet, frmSuburb, frmCity, postCode, frmEmail, frmPhone, emailAllowed]);


    function storeOwnerNoChange() {

        let body = {
            "owner_first": row['first'],
            "owner_last": row['last'],
            "owner_street_number": row.street_number,
            "owner_street": row.street,
            "owner_suburb": row.suburb,
            "owner_city": row.city,
            "owner_postcode": row.postcode,
            "owner_email": row.email,
            "owner_phone": row.phone,
            "owner_formatted_address": row.formatted_address,
            "owner_verified": 1,
            "owner_email_allowed": (emailAllowed === true) ? 1 : 0
        }

        if (row.is_redeemed === 0) {

            FunctionsData.postData(
                FunctionsData.getApiUrl("/api/voucher/update/") + row.id,
                body
            ).then((r) => {
                setRow({...row, ...body});
                setVerified(true);
            })
            ;

        } else {
            setRow({...row, ...body});
            setVerified(true);
        }


    }

    function storeOwnerNoVerification() {

        let body = {
            "owner_verified": 0,
        }

        FunctionsData.postData(
            FunctionsData.getApiUrl("/api/voucher/update/") + row.id,
            body
        ).then((r) => {
            //console.log("/api/voucher/update/" + row.id, {...row, "owner_verified":0});
            setRow({...row, ...body});
            setVerified(false);
        })
        ;

    }

    function storeEmailAllowed() {

        const emAl = !emailAllowed;
        setEmailAllowed(!emailAllowed);
        
		let body = {
            "owner_email_allowed": (!emAl === true) ? 1 : 0
        }

        FunctionsData.postData(
            FunctionsData.getApiUrl("/api/voucher/update/") + row.id,
            body
        )
    }

    function storeOwner() {

        let formatted = frmStreetNumber + ' ' + frmStreet + ", " + frmSuburb + ", " + frmCity + ", " + postCode

        let body = {
            "owner_first": frmFn,
            "owner_last": frmLn,
            "owner_street": frmStreet,
            "owner_street_number": frmStreetNumber,
            "owner_suburb": frmSuburb,
            "owner_city": frmCity,
            "owner_postcode": postCode,
            "owner_email": frmEmail,
            "owner_phone": frmPhone,
            "owner_formatted_address": formatted,
            "owner_verified": 1,
            "owner_email_allowed": (emailAllowed === true) ? 1 : 0
        }
	    
		//todo check if the voucher is redeemed
	    FunctionsData.postData(
		    FunctionsData.getApiUrl("/api/voucher/update/") + row.id,
		    body
	    ).then((r) => {
		    setRow({...row, ...body});
		    setVerified(true);
		    setChange(false);
	    })
	    ;
    }


    if (change === true) return (
        <div className={"animal-form"}>
            <h1 style={{marginBottom: 20}}>Voucher #{row.sn}</h1>
            <h3 style={{marginBottom: 30}}>Please provide the new owner details:</h3>
            <ShowEmailDisable storeEmailAllowed={storeEmailAllowed} emailAllowed={emailAllowed}/>
            <div style={{width: 400}}>
                <FormControl fullWidth sx={{marginBottom: 2}}>
                    <TextField
                        error={(frmFn === '')}
                        label="First name"
                        type="text"
                        value={frmFn}
                        onChange={(e) => setFrmFn(e.target.value)}
                        focused={"true"}
                    />
                </FormControl>
                <FormControl fullWidth sx={{marginBottom: 2}}>
                    <TextField
                        error={(frmLn === '')}
                        label="Last name"
                        type="text"
                        value={frmLn}
                        onChange={(e) => setFrmLn(e.target.value)}
                        focused={"true"}
                    />

                </FormControl>

                <div style={{display: 'flex', flex: '1 0 100%'}}>
                    <div style={{flexGrow: 0, width: 150, marginRight: 5}}>
                        <FormControl fullWidth sx={{marginBottom: 1}}>
                            <TextField
                                error={(frmStreetNumber === '')}
                                label="Street number"
                                type="text"
                                value={frmStreetNumber}
                                onChange={(e) => setFrmStreetNumber(e.target.value)}
                                focused={"true"}
                            />
                        </FormControl>
                    </div>
                    <FormControl fullWidth sx={{marginBottom: 2}}>
                        <TextField
                            error={(frmStreet === '')}
                            label="Street"
                            type="text"
                            value={frmStreet}
                            onChange={(e) => setFrmStreet(e.target.value)}
                            focused={"true"}
                        />
                    </FormControl>
                </div>
                <FormControl fullWidth sx={{marginBottom: 2}}>
                    <TextField
                        error={(frmCity === '')}
                        label="Suburb"
                        type="text"
                        value={frmSuburb}
                        onChange={(e) => setFrmSuburb(e.target.value)}
                        focused={"true"}
                    />
                </FormControl>
                <FormControl fullWidth sx={{marginBottom: 2}}>
                    <TextField
                        error={(frmCity === '')}
                        label="City"
                        type="text"
                        value={frmCity}
                        onChange={(e) => setFrmCity(e.target.value)}
                        focused={"true"}
                    />
                </FormControl>
                <FormControl fullWidth sx={{marginBottom: 2}}>
                    <TextField
                        error={(postCode === '')}
                        value={postCode}
                        label="Postcode"
                        type="text"
                        onChange={(e) => setPostCode(e.target.value)}
                        focused={"true"}
                    />
                </FormControl>

                <FormControl fullWidth sx={{marginBottom: 2}}>
                    <TextField
                        error={!validateEmail(frmEmail,emailAllowed)}
                        label="Email"
                        type="email"
                        aria-describedby="email-helper-text"
                        value={frmEmail}
                        onChange={(e) => setFrmEmail(e.target.value)}
                        focused={"true"}
                    />
                    <FormHelperText id="email-helper-text">
                        This email address will be used to register the microchip on NZCAR.
                    </FormHelperText>
                </FormControl>

                <FormControl fullWidth sx={{marginBottom: 2}}>
                    <TextField
                        error={(frmPhone === '' || !phoneValid)}
                        label="Phone number"
                        type="phone"
                        aria-describedby="component-helper-text"
                        value={frmPhone}
                        onChange={(e) => setFrmPhone(e.target.value)}
                        focused={"true"}
                    />
                </FormControl>

                <Button disabled={!valid} variant={"contained"} onClick={() => storeOwner()}>Add new owner details</Button>
                <Button onClick={() => setChange(false)}>Cancel</Button>
            </div>
        </div>
    )

    return (
        <div className={"animal-form"}>
            <RedeemVoucherShowHeaderOwner row={row}  />
            <ShowEmailDisable storeEmailAllowed={storeEmailAllowed} emailAllowed={emailAllowed}/>

            <div>
                <ShowVerifiedButton row={row} {...{storeOwnerNoVerification, storeOwnerNoChange,setChange}}/>
            </div>

            {
                (row.owner_verified === 1) ?
                    <div>
                        <div style={{paddingBottom: 20}}></div>
                        <RedeemVoucherShowAnimalSingleForm
                            key={animal.id}
                            animal={animal}
                            setAnimal={setAnimal}
                            rowInstance={row}
                            setRowInstance={setRow}
                            setShowModal={setShowModal}
                            showModal={showModal}
                            reloadOriginal={setReloadOriginal}
                            microchips={microchips}
                            verified={verified}
                        />
                    </div>
                    : undefined
            }

        </div>
    )

}

const ShowVerifiedButton = ({storeOwnerNoVerification, row,storeOwnerNoChange,setChange}) => {
    if (row.owner_verified === 1) return (
        <div style={{marginTop: 10}}>
            <Button onClick={() => storeOwnerNoVerification()}
                    variant={"contained"}
                    sx={{padding: '2px 10px', marginLeft: 0, background: 'green'}}>
                The owner is verified. Click here to change it.
            </Button>
        </div>
    )

    return (
        <div style={{marginTop: 10}}>
            <Button onClick={() => storeOwnerNoChange()}
                    variant={"contained"}
                    sx={{padding: '2px 10px', marginLeft: 0, background: 'red'}}
            >Verify the above as owner</Button>
            <Button onClick={() => {
                setChange(true);
            }} variant={"contained"} sx={{
                padding: '2px 10px', marginLeft: 1
            }}>Add a new owner</Button>
        </div>
    )
}

function validateEmail(email,emailAllowed) {
    const re = /\S+@\S+\.\S+/;
    return re.test(email) || (emailAllowed === false);
}

function validatePhone(phone) {
    let rePhone = /^(((\+64\s*[-\.]?[3-9]|\(?0[3-9]\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{4})|((\+?64\s*[-\.\(]?2\d{1}[-\.\)]?|\(?02\d{1}\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{3,5})|((\+?64\s*[-\.]?[-\.\(]?800[-\.\)]?|[-\.\(]?0508[-\.\)]?|[-\.\(]?0800[-\.\)]?)\s*[-\.]?\d{3}\s*[-\.]?(\d{3,4}|\d{6,7})))$/;
    return (rePhone.test(phone) && phone !== '');
}

function ShowEmailDisable ({emailAllowed,storeEmailAllowed}) {
	return (
		<div style={{marginBottom: 10, marginTop: 10, background: 'transparent'}}>
			<FormControlLabel style={{fontSize: '5px !important'}}
			                  control={<Switch checked={emailAllowed} onChange={(e) => {
				                  storeEmailAllowed();
			                  }}/>} label="Include email in owner record"/>
		</div>
	)
}
